export const dataToCostAnalysisReportList = (data: any) => {
  return data.map((item: any) => ({
    productName: item.parent_product_name,
    sku: item.parent_product_sku,
    currentCostPrice: item.cost_range ? '$' + item.cost_range : '-',
    costMargin: item.cost_margin !== null ? item.cost_margin?.toFixed(2) : null,
    lastPoCostPrice: item.latest_po_cost_range ? '$' + item.latest_po_cost_range : '-',
    averageCostOfLast3Pos: item.po_avg_cost_range ? '$' + item.po_avg_cost_range : '-',
    minVariantCostPrice: item.min_variant_cost,
    variants: item.variants || [],
  }))
}

export const COST_ANALYSIS_REPORT_TABLE_COLUMNS = [
  {
    key: 'parent_product_name',
    label: 'Product',
    isSorted: true,
    headerStyle: 'min-w-250px',
  },
  {
    key: 'parent_product_sku',
    label: 'SKU',
    isSorted: true,
    headerStyle: 'min-w-150px',
  },
  {
    key: 'cost_range',
    label: 'Current Cost Price',
    isSorted: true,
    headerStyle: 'min-w-200px',
  },
  {
    key: 'latest_po_cost_range',
    label: 'Last PO Cost Price',
    isSorted: true,
    headerStyle: 'min-w-200px',
  },
  {
    key: 'po_avg_cost_range',
    label: 'Average Cost of Last 3 POS',
    isSorted: true,
    style: 'justify-content-end',
    headerStyle: 'min-w-250px',
  },
]
